const lastOf = <T>(input: T[]) => input[input.length - 1];
const isLastIndexOf = <T>(index: number, input: T[]) =>
    index === input.length - 1;
const firstOf = <T>(input: T[]) => input[0];

export { firstOf, isLastIndexOf, lastOf };
